import { useEffect, useCallback } from "react";

/**
 * Modal Component
 * Reusable modal with backdrop blur
 */
export function Modal({ isOpen, onClose, children, className = "" }) {
  // Close on escape key
  const handleKeyDown = useCallback(
    (e) => {
      if (e.key === "Escape") {
        onClose();
      }
    },
    [onClose],
  );

  useEffect(() => {
    if (isOpen) {
      document.addEventListener("keydown", handleKeyDown);
      document.body.style.overflow = "hidden";
    }
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
      document.body.style.overflow = "";
    };
  }, [isOpen, handleKeyDown]);

  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 flex flex-col items-center justify-center z-[9999]
                 bg-black/40 backdrop-blur-[30px] transition-all"
      onClick={onClose}
    >
      <div
        className={`relative w-[90%] max-w-fit max-h-[90vh] h-fit
                    bg-white rounded-[2.5rem] p-10
                    max-md:p-4 max-md:rounded-[1.2rem]
                    ${className}`}
        onClick={(e) => e.stopPropagation()}
      >
        {children}
      </div>
      <button
        onClick={onClose}
        className="block mt-6 mx-auto py-3 px-8
                   bg-white/10 text-white rounded-[99rem]
                   font-semibold text-xl text-center
                   border border-white/[0.03]
                   transition-all hover:-translate-y-0.5 active:translate-y-0
                   hover:bg-white/15
                   max-md:mt-4 max-md:py-2 max-md:px-6 max-md:text-base"
      >
        Close
      </button>
    </div>
  );
}

/**
 * SupplementFactsModal Component
 * Specific modal for displaying supplement facts
 */
export function SupplementFactsModal({ isOpen, onClose, imageSrc }) {
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <img
        src={imageSrc}
        alt="Supplement Facts"
        className="w-full h-auto max-h-[calc(90vh-8rem)] block object-contain"
      />
    </Modal>
  );
}

export default Modal;
